import { jsx as _jsx } from "react/jsx-runtime";
import { useStoreActions } from '~/store/store-context';
import { BusinessChannelEventBinder, PusherEvent } from '../pusher';
/** Binds a callback to the pusher event for getting kyc status updates. */ export default function KycStatusBinder() {
    const { fetchUserInfo } = useStoreActions();
    // fetch user info to update the worksAt so the kyc failed banner will be shown
    const callback = fetchUserInfo;
    return /*#__PURE__*/ _jsx(BusinessChannelEventBinder, {
        source: "mgmt",
        eventName: PusherEvent.KYCStatusUpdated,
        callback: callback
    });
}
